export default "__VITE_ASSET__Dl0Aia6U__"